// src/data/toursData.js

import zanz1 from "../src/assets/image/zanz1.jpg";
import zanz2 from "../src/assets/image/zanz2.jpg";
import zanz3 from "../src/assets/image/zanz3.jpg";
import zanz4 from "../src/assets/image/zanz4.jpg";
import zanz5 from "../src/assets/image/zanz5.jpg";
import zanz6 from "../src/assets/image/zanz6.jpg";
import zanz7 from "../src/assets/image/zanz7.jpg";
import zanz8 from "../src/assets/image/zanz8.jpg";
import jozani1 from "../src/assets/image/jozani/jozani1.jpg";
import jozani2 from "../src/assets/image/jozani/jozani2.jpg";
import jozani3 from "../src/assets/image/jozani/jozani3.jpg";
import jozani4 from "../src/assets/image/jozani/jozani4.jpg";
import jozani5 from "../src/assets/image/jozani/jozani5.jpg";
import jozani6 from "../src/assets/image/jozani/jozani6.jpg";
import jozani7 from "../src/assets/image/jozani/jozani7.jpg";
import jozani from "../src/assets/image/jozani/jozani.jpg";
import spice from "../src/assets/image/spice/spice.jpg";
import spice1 from "../src/assets/image/spice/spice1.jpg";
import spice2 from "../src/assets/image/spice/spice2.jpg";
import spice3 from "../src/assets/image/spice/spice3.jpg";
import spice4 from "../src/assets/image/spice/spice4.jpg";
import spice5 from "../src/assets/image/spice/spice5.jpg";
import spice7 from "../src/assets/image/spice/spice7.jpg";
import stone from "../src/assets/image/stonetown/stonetown.jpg";
import stone2 from "../src/assets/image/stonetown/stonetown2.jpg";
import stone3 from "../src/assets/image/stonetown/stonetown3.jpg";
import stone4 from "../src/assets/image/stonetown/stonetown4.jpg";
import stone5 from "../src/assets/image/stonetown/stonetown5.avif";
import stone6 from "../src/assets/image/stonetown/stonetown6.jpg";
import stone7 from "../src/assets/image/stonetown/stonetown7.jpg";
import stone8 from "../src/assets/image/stonetown/stonetown8.jpg";
import stone10 from "../src/assets/image/stonetown/stonetown10.jpg";
import stone11 from "../src/assets/image/stonetown/stonetown11.jpg";
import stone13 from "../src/assets/image/stonetown/stonetown13.jpg";
import stone12 from "../src/assets/image/stonetown/stonetown12.jpg";
import mnemba from "../src/assets/image/mnemba/mnemba.jpg";
import mnemba1 from "../src/assets/image/mnemba/mnemba1.jpg";
import mnemba2 from "../src/assets/image/mnemba/mnemba2.jpg";
import mnemba3 from "../src/assets/image/mnemba/mnemba3.jpg";
import mnemba4 from "../src/assets/image/mnemba/mnemba4.jpg";
import mnemba5 from "../src/assets/image/mnemba/mnemba5.jpg";
import mnemba6 from "../src/assets/image/mnemba/mnemba6.jpg";
import mnemba7 from "../src/assets/image/mnemba/mnemba7.jpg";
import mnemba8 from "../src/assets/image/mnemba/mnemba8.jpg";
import mnemba9 from "../src/assets/image/mnemba/mnemba9.jpg";
import mnemba10 from "../src/assets/image/mnemba/mnemba10.jpg";
import mnemba11 from "../src/assets/image/mnemba/mnemba11.jpg";
import mnemba12 from "../src/assets/image/mnemba/mnemba12.jpg";
import mnemba13 from "../src/assets/image/mnemba/mnemba13.jpg";
import mnemba14 from "../src/assets/image/mnemba/mnemba14.jpg";
import nakupenda from "../src/assets/image/nakupenda/nakupendasandbank.jpg";
import nakupenda1 from "../src/assets/image/nakupenda/nalupenda1.jpg";
import nakupenda2 from "../src/assets/image/nakupenda/nakupenda6.jpg";
import nakupenda3 from "../src/assets/image/nakupenda/nakupenda5.jpg";
import nakupenda4 from "../src/assets/image/nakupenda/nakupenda2.jpg";
import prison from "../src/assets/image/prison/prisonisland.jpg";
import prison2 from "../src/assets/image/prison/prisonisland2.avif";
import prison3 from "../src/assets/image/prison/prisonisland3.jpg";
import prison4 from "../src/assets/image/prison/prisonisland4.jpg";
import prison5 from "../src/assets/image/prison/prisonisland5.jpg";
import prison6 from "../src/assets/image/prison/prisonisland6.jpg";
import prison7 from "../src/assets/image/prison/prisonisland7.jpg";
import rock from "../src/assets/image/rock/rock.jpg";
import rock2 from "../src/assets/image/rock/rock2.jpg";
import rock3 from "../src/assets/image/rock/rock3.jpg";
import rock4 from "../src/assets/image/Folder1/rock.jpg";
import rock5 from "../src/assets/image/Folder1/rock1.jpg";
import sunset from "../src/assets/image/sunset/sunset.jpg"
import sunset1 from "../src/assets/image/sunset/sunset1.jpg"
import sunset2 from "../src/assets/image/sunset/sunset2.jpg"
import sunset3 from "../src/assets/image/sunset/sunset3.jpg"
import sunset4 from "../src/assets/image/sunset/sunset4.jpg"
import sunset5 from "../src/assets/image/sunset/sunset5.jpg"
import sunset6 from "../src/assets/image/sunset/sunset6.jpg"
import sunset7 from "../src/assets/image/sunset/sunset7.jpg";
import sal1 from "../src/assets/image/Folder1/sal1.jpg"
import sal2 from "../src/assets/image/Folder1/sal2.jpg"
import sal3 from "../src/assets/image/Folder1/salaam.jpg"
import beach1 from "../src/assets/image/Folder1/beac.jpg"
import beach2 from "../src/assets/image/Folder1/beach.jpg"
import beach3 from "../src/assets/image/Folder1/beach2.jpg"
import beach4 from "../src/assets/image/Folder1/beach3.jpg"
import beach5 from "../src/assets/image/Folder1/beach4.jpg"
import beach6 from "../src/assets/image/Folder1/beach5.jpg"
import car1 from "../src/assets/image/Folder1/car.jpg"
import car2 from "../src/assets/image/Folder1/car1.jpg"
import car3 from "../src/assets/image/Folder1/car2.jpg"
import car4 from "../src/assets/image/Folder1/car3.jpg"
import car5 from "../src/assets/image/Folder1/car4.jpg"
import car6 from "../src/assets/image/Folder1/car6.jpg"
import safariBg from "../src/assets/image/Folder1/desti.jpg"
import farasi from "../src/assets/image/Folder1/farasi1.jpg"
import farasi1 from "../src/assets/image/Folder1/farasi2.jpg"
import farasi2 from "../src/assets/image/Folder1/farasi3.jpg"
import farasi3 from "../src/assets/image/Folder1/farasi4.jpg"
import farasi4 from "../src/assets/image/Folder1/farasi5.jpg"
import farasi5 from "../src/assets/image/Folder1/farasi6.jpg"
import farasi6 from "../src/assets/image/Folder1/farasi7.jpg"
import seaFood from "../src/assets/image/Folder1/seafood.jpg"
import blue1 from "../src/assets/image/Folder1/blue1.jpg"
import blue2 from "../src/assets/image/Folder1/blue2.jpg"
import blue3 from "../src/assets/image/Folder1/blue3.jpg"
import blue4 from "../src/assets/image/Folder1/blue4.jpg"
import kayaking from "../src/assets/image/Folder1/kayaking.jpg"
import quad from "../src/assets/image/Folder1/quad.jpg"
import maa1 from "../src/assets/image/Folder1/maa1.jpeg"
import maa2 from "../src/assets/image/Folder1/maa2.jpeg"
import maa3 from "../src/assets/image/Folder1/maa3.jpeg"
import maa4 from "../src/assets/image/Folder1/maa4.jpg"
import maa5 from "../src/assets/image/Folder1/maa5.jpg"
import pung1 from "../src/assets/image/Folder1/pung1.jpeg"
import pung2 from "../src/assets/image/Folder1/pung2.jpeg"
import pung3 from "../src/assets/image/Folder1/pung3.jpg"
import pung4 from "../src/assets/image/Folder1/pung4.jpg"


export const tourCategories = [
    {
        id: "vip",
        title: "Special Packages Zanzibar",
        description:
            "Exclusive luxury experiences with private guides and premium services",
        image: mnemba,
        featured: true,
    },
    {
        id: "private",
        title: "Private ZanStone Tours",
        description:
            "Personalized tours tailored to your preferences with private transportation",
        image: stone2,
        featured: true,
    },
    {
        id: "sharing",
        title: "Sharing Trips",
        description:
            "Group tours for budget-conscious travelers with shared transportation",
        image: zanz3,
        featured: true,
    },
      {
        id: "optional",
        title: "Optional Activities",
        description:
            "Boost your Zanzibar experience with these popular activities",
        image: farasi4,
        featured: true,
    }, 
    {
        id: "transfer",
        title: "Transfer Price",
        description:
            "Your safety and luggage security are always our top priority",
        image: car6,
        featured: true,
    },
];

export const allTours = {
    
    private: [
        {
            id: "kendwa-sunset",
            name: "Kendwa Sunset Cruise Private Experience",
            category: "Private",
            startPoint: "Kendwa beach",
            time: "17:00 PM ",
            type: "Private | Romantic | Luxury | Evening Cruise | Unforgettable",
            price: "$300 for 3-5 persons | $400 for 6-10 persons | $500 for 11+ persons",
            description:
                "The Kendwa Sunset Cruise is a private evening escape along the stunning north coast of Zanzibar. Set sail from Kendwa Beach aboard a traditional dhow or modern speedboat as you chase the golden sun dipping below the Indian Ocean horizon. With soft music, drinks, and a warm sea breeze, this cruise is designed for romance, celebrations, or pure relaxation.Perfect for couples, small groups, or families who want to end their day in style. To book, simply let us know your group size and we’ll prepare everything for your private sunset experience.",
            image: sunset6,
            images: [sunset7, sunset5, sunset4, sunset,sunset1,sunset2],
            itinerary: [
                {
                    title: "Pick-Up & Transfer to Kendwa Beach",
                    description: `Your private driver will pick you up from your hotel and bring you to Kendwa Beach, one of Zanzibar’s most beautiful coastal locations.`,
                },
                {
                    title: "Boarding the Boat",
                    description: `Meet your friendly crew and board your private boat.
Traditional dhow or modern speedboat options available
sun deck, and music system included
Cold drinks are served on board`,
                },
                {
                    title: "Sunset Sailing Experience",
                    description: `Cruise gently along the coast of Kendwa and Nungwi
Watch the sky turn into a painting of orange, pink, and gold
Perfect time for couples, proposals, or celebrating a special moment
Music plays softly in the background, or you can bring your own playlist`,
                },
                {
                    title: "Drinks & Light Refreshments",
                    description: `Enjoy cold soft drinks, bottled water
Option to upgrade to a wine or champagne package (upon request)
Light snacks or fruit platters available on board`,
                },
                {
                    title: "Return & Hotel Drop-Off",
                    description: `After sunset, the boat returns to Kendwa Beach. Your driver will take you back to your hotel.`,
                },



                // More itinerary items...
            ],
            inclusions: [
                "Private boat (traditional dhow or speedboat)",
                "Hotel pick-up and drop-off",
                "English-speaking crew",
                "Music system on board",
                "Soft drinks, water",
                "Light refreshments or fruits",
                "All local fees and permits",
                "Government taxes and VAT"
            ],

            OptionalAddOns: [
                "Premium champagne or cocktails",
                "Proposal or anniversary setup",
            ],

            // Add other details from your DOCX file...
        },

        {
            id: "Jozani-Forest-Private",
            name: "Jozani Forest & Salaam Cave with Turtle Interaction Private Day Tour",
            category: "Private",
            startPoint: "Jozani Forest",
            time: "08:00 AM",
            type: "Private | Romantic | Luxury | Unforgettable",
            price: "$200 for two persons | $245 for three persons | $280 for four persons | $65 for 5-10 per person | $60 for 11+ per person",
            description:
                `Explore Zanzibar’s incredible nature on this private tour featuring the lush Jozani Forest and the enchanting Salaam Cave, where you can swim with and feed turtles in their natural habitat. This tour is perfect for wildlife lovers and families seeking a mix of adventure, relaxation, and unique animal encounters.
Ideal for couples, families, and groups who want to experience Zanzibar’s biodiversity and wildlife up close. Booking is easy — just share your preferred date and group size.`,
            image: jozani1,
            images: [jozani, jozani2, jozani3, jozani4, jozani5, jozani6],
            itinerary: [
                {
                    title: "Hotel Pick-Up & Transfer to Jozani Forest",
                    description: `Your driver will collect you from your hotel and take you to Jozani Chwaka Bay National Park.`,
                },
                {
                    title: "Stop 1: Jozani Forest Walk",
                    description: `Guided walk through the tropical forest
See endangered Red Colobus monkeys, bush babies, and diverse birds
Discover mangrove ecosystems and the famous boardwalk over the mangroves`,
                },
                {
                    title: "Transfer to Salaam Cave Turtle Sanctuary",
                    description: `Drive to Salaam Cave, renowned for its natural freshwater pools and a special turtle sanctuary where you can interact with the turtles.`,
                },
                {
                    title: "Stop 2: Salaam Cave & Turtle Interaction",
                    description: `Swim in the fresh waters of the coral cave pools
Feed and swim with friendly turtles in a safe, controlled environment
Relax on floating cushions or life jackets while enjoying light music and tropical fruit refreshments
Learn about turtle conservation efforts in Zanzibar`,
                },
                {
                    title: "Return to Hotel",
                    description: `After your unforgettable day, transfer back to your hotel.`,
                },



                // More itinerary items...
            ],
            inclusions: [
                "Private round-trip transfers",
                "Entrance to Jozani Forest National Park",
                "Entrance to Jozani Forest and Salaam Cave turtle sanctuary",
                "Guided forest walk and turtle interaction session",
                "Refreshments: tropical fruits, soft drinks",
                "All government and local taxes",
                "Professional guide",
                "All VAT"
            ],

            OptionalAddOns: [
                "Premium champagne or cocktails",
                "Proposal or anniversary setup",
            ],

        },

        {
            id: "Mnemba-Atoll-Private",
            name: "Mnemba Atoll Dolphin & Snorkeling Trip Private Tour",
            category: "Private",
            startPoint: "Matemwe Beach",
            time: "08:00 AM",
            type: "Private | Romantic | Luxury | Unforgettable",
            price: "$220 for two persons | $240 for three persons | $255 for four persons | $65 for 5-10 per person | $60 for 11+ per person",
            description:
                `The Mnemba Atoll Dolphin & Snorkeling Trip is one of the most popular sea experiences in Zanzibar. This private version is tailored for travelers looking for a relaxed and personalized ocean adventure. The trip combines ethical dolphin watching, world-class snorkeling, and a delicious seafood lunch served on beach.
Perfect for couples, families, and groups who want to experience the beauty of the Indian Ocean in privacy and style. Just let us know your group size and preferred date, and we’ll arrange your full experience from hotel to sea and back.`,
            image: mnemba,
            images: [mnemba10, mnemba11, mnemba12, mnemba14,mnemba9,mnemba8,mnemba7,mnemba6,mnemba5,mnemba4,mnemba3,mnemba2],
            itinerary: [
                {
                    title: "Pick-Up & Departure from Matemwe Beach",
                    description: `Your driver will pick you up from your hotel and take you to the boat departure point in the north of Zanzibar (Matemwe). Meet your captain and hop aboard your private boat.`,
                },
                {
                    title: "Dolphin Watching (Ethical & Respectful)",
                    description: `Sail into the open sea in search of wild bottlenose dolphins.
Watch them playfully swim in pods
Take photos from the boat at a respectful distance
This part of the trip is done with care for the animals' natural behavior`,
                },
                {
                    title: "Snorkeling at Mnemba Atoll",
                    description: `Reach the reef near Mnemba Island, one of the best snorkeling sites in East Africa.
Snorkel over vibrant coral gardens teeming with tropical fish
All snorkeling gear is provided, and life jackets are available for non-swimmers
Explore underwater life with the help of your private guide`,
                },
                {
                    title: "Seafood Lunch on the beach",
                    description: `After swimming, enjoy a relaxing lunch served on beach.
Grilled fish, prawns, chicken, rice, salad, and tropical sauces
Fresh fruits: pineapple, watermelon, bananas
Soft drinks and bottled water available on deck`,
                },
                {
                    title: "Relaxation & Return",
                    description: `Chill out with drinks, and sunshine as you sail back to shore. Our driver will take you back to your hotel.`,
                },



                // More itinerary items...
            ],
            inclusions: [
                "Private boat charter (with crew & guide)",
                "Dolphin search trip (respectful & non-invasive)",
                "Snorkeling gear and life jackets",
                "Seafood lunch on beach (fish, prawns, chicken, fruits)",
                "Bottled water, soft drinks and fresh fruits",
                "Pick-up and return transfers from your hotel",
                "Professional guide",
                "All marine park and government fees",
                "All taxes and VAT"
            ],

            OptionalAddOns: [
                "Premium champagne or cocktails",
                "Proposal or anniversary setup",
            ],

        },

        {
            id: "nakupenda-Private",
            name: "Nakupenda Sandbank & Prison Island Private Tour",
            category: "Private",
            startPoint: "Stone Town Beach",
            time: "08:00 AM",
            type: "Private | Romantic | Luxury | Unforgettable",
            price: "$250 for two persons | $265 for three persons | $280 for four persons | $70 for 5-10 per person | $65 for 11+ per person",
            description: `This private full-day tour combines the charm of Zanzibar’s history with its natural beach beauty. You'll visit Prison Island, home to the iconic Aldabra giant tortoises and colonial ruins, followed by a relaxing escape to Nakupenda Sandbank. Enjoy fresh seafood, soft drinks, fruits, and a peaceful swim in turquoise waters.
Whether you're traveling as a couple, family, or a group, this package is designed for those who want to explore, relax, and taste the best of Zanzibar in a single day. Booking is simple — just contact us with your group size, and we’ll arrange the rest.`,
            image: nakupenda1,
            images: [prison2,nakupenda,prison,nakupenda2,prison3,nakupenda3],
            itinerary: [
                {
                    title: "Pick-Up & Departure from Stone Town Beach",
                    description: `Your guide and private boat crew will meet you at Stone Town Beach for departure. After a short briefing, you’ll board a local luxury boat equipped with music, drinks, and seating.`,
                },
                {
                    title: "Stop 1: Prison Island Tour",
                    description: `Sail to the historic Prison Island (Changuu Island) where you’ll:
Learn about its history as a former prison and quarantine station
Visit the sanctuary for giant Aldabra tortoises, some over 150 years old
Explore the colonial ruins and enjoy scenic views`,
                },
                {
                    title: "Stop 2: Nakupenda Sandbank",
                    description: `Continue your trip to Nakupenda, a sandbank surrounded by crystal-clear blue waters. Here you will:
Relax, swim, and sunbathe in a peaceful paradise
Snorkel around shallow waters (gear provided)
Enjoy a delicious seafood lunch served on board including grilled fish, prawns, chicken, rice, salad, sauces, and fruits
Listen to music, sip cold drinks, and enjoy the island vibes`,
                },

                {
                    title: "Return to Stone Town",
                    description: `After a memorable afternoon on the ocean, you’ll return to Stone Town Beach where your driver will take you back to your hotel if needed.`,
                },



                // More itinerary items...
            ],
            inclusions: [

                "Private local boat",
                "Entrance fees",
                "Guided tour with professional English-speaking guide",
                "Seafood lunch on board (fish, prawns, chicken, rice, fruits)",
                "Soft drinks, bottled water, and local beers",
                "Snorkeling gear and life jackets",
                "Music on the boat",
                "Hotel transfers",
                "All government fees and marine park charges"
            ],

            OptionalAddOns: [
                "Premium champagne or cocktails",
                "Proposal or anniversary setup",
            ],

        },


        {
            id: "pungume island-Private",
            name: "Pungume Island Adventure Private Full Day Trip",
            category: "Private",
            startPoint: "Stone Town Beach",
            time: "08:00 AM",
            type: "Private | Romantic | Luxury | Unforgettable",
            price: "$260 for two persons | $275 for three persons | $290 for four persons | $70 for 5-10 per person | $60 for 11+ per person",
            description: `Discover the untouched beauty of Pungume Island, a pristine and secluded paradise located southwest of Stone Town. This private full-day adventure offers a combination of snorkeling, swimming, relaxing on white sandy beaches, and exploring vibrant marine life. Ideal for travelers seeking tranquility away from crowds with a touch of nature’s magic.
Perfect for couples, families, and groups wanting a unique, personalized island experience. Simply provide your group size and preferred date, and we will arrange transfers, boat charter, meals, and snorkeling gear.`,
            image: pung4,
            images: [pung2, pung3, pung1],
            itinerary: [
                {
                    title: "Pick-Up & Transfer to Boat Departure Point",
                    description: `Our driver will pick you up from your hotel in Stone Town or surrounding areas and transfer you to the boat launch site.`,
                },
                {
                    title: "Boat Ride to Pungume Island",
                    description: `Board a private boat and enjoy a scenic sail through the crystal-clear waters of Zanzibar’s west coast
Take in the views of mangroves, sandbanks, and ocean life along the way`,
                },
                {
                    title: "Exploration & Snorkeling at Pungume Island",
                    description: `Arrive at the unspoiled Pungume Island surrounded by coral reefs
 Snorkel among colorful tropical fish, corals, and possibly sea turtles.
 Relax on the white sandy beach or swim in calm, warm waters.
 Enjoy sunbathing, beach games, and beach photography opportunities`,
                },

                {
                    title: "Lunch on Board or Beach Picnic",
                    description: `Savor a delicious freshly prepared lunch featuring seafood, chicken, rice, salads, and fresh fruits
 Accompanied by soft drinks, water, and local beers.
 Option to have lunch on the boat or a picnic on the beach.`,
                },
                {
                    title: "Leisure & Return",
                    description: `Spend the afternoon at leisure exploring or relaxing.
Return by boat to the departure point.
Transfer back to your hotel.`,
                },



                // More itinerary items...
            ],
            inclusions: [

                "Private boat charter with crew",
                "Hotel pick-up and drop-off",
                "Snorkeling gear and life jackets",
                "Fresh seafood lunch (fish, chicken, rice, fruits)",
                "Soft drinks, bottled water",
                "Professional guide",
                "Marine park entrance fees",
                "All local taxes and government fees",
                "All VAT"
            ],

            OptionalAddOns: [
                "Premium champagne or cocktails",
                "Proposal or anniversary setup",
            ],

        },

        {
            id: "Zanzibar-5-days-Private",
            name: "Zanzibar 5 Days / 4 Nights Package Private Tour",
            category: "Private",
            startPoint: "Zanzibar Airport",
            time: "5Days / 4 Nights",
            type: "Private | Romantic | Luxury | Unforgettable",
            price: "$810 for two person",
            description: `Travelers seeking a perfect mix of adventure, relaxation, and cultural discovery`,
            image: stone,
            images: [nakupenda1, prison7, zanz7],
            itinerary: [
                {
                    title: "Day 1: Arrival in Zanzibar",
                    description: `✈️ Meet & Greet at Zanzibar International Airport
 🚐 Private transfer to your hotel for check-in,
 🌴 Free time to relax on the beach or explore at your own pace,
 🏨 Overnight stay at your hotel.`,
                },
                {
                    title: "Day 2: Nakupenda Sandbank & Prison Island Tour",
                    description: `🐢 Visit Prison Island to see giant Aldabra tortoises and historical sites
 🏖️ Continue to Nakupenda Sandbank for sunbathing, snorkeling, and swimming,,
 🍤 Enjoy a delicious seafood BBQ lunch on the sandbank,
 📸 Return to hotel with unforgettable memories,
 🏨 Overnight stay at your hotel.`,
                },
                {
                    title: "Day 3: Maalum & Salaam Caves",
                    description: `🕳️ Discover the Salaam Cave, home to turtles and natural underground pools,
 💧 Swim in the tranquil, turquoise water of Maalum Cave,
 🧘‍♂️ A peaceful day immersed in nature and wellness,
 🏨 Overnight stay at your hotel.`,
                },

                {
                    title: "Day 4: Safari Blue Adventure",
                    description: `⛵ Board a traditional dhow boat for a full-day marine safari, 
🐬 Dolphin spotting, snorkeling at coral reefs, and sandbank lounging, 
🍽️ Indulge in a seafood buffet lunch with tropical fruits and soft drinks, 
🌿 Explore mangroves and natural lagoons in Menai Bay, 
🏨 Overnight stay at your hotel.`,
                },
                {
                    title: "Day 5: Departure Day",
                    description: `☕ Breakfast at your hotel, 
🚐 Transfer to Zanzibar Airport, 
👋 Farewell and safe travels — Asante Sana & Karibu Tena!`,
                },



                // More itinerary items...
            ],
            inclusions: [

                "✈️ Airport Transfers (Arrival & Departure)",
                "🛥️ All tours and activities as per itinerary",
                "🥗 Seafood Lunch on Day 2 & Day 4",
                "🚐 Private transportation for all excursions",
                "🐢 All entrance & conservation fees",
                "🧍 Professional English-speaking guide",
                "🧾 Government taxes & VAT",
                "🥤 Soft drinks and fresh fruits during tours",
                "🥽 Snorkeling equipment"
            ],

            OptionalAddOns: [
                "Premium champagne or cocktails",
                "Proposal or anniversary setup",
            ],

        },


        {
            id: "Safari-Blue-Private",
            name: "Safari Blue Adventure Private Tour",
            category: "Private",
            startPoint: "Fumba Beach",
            time: "09:00 am",
            type: "Private | Romantic | Luxury | Unforgettable",
            price: "$250 for two persons | $265 for three persons | $280 for four persons | $70 for 5-10 per person | $65 for 11+ per person",
            description: `The Safari Blue Adventure is one of Zanzibar’s most iconic ocean excursions — and this version offers full privacy, comfort, and personalized service. Sail across the turquoise waters of Menai Bay in a traditional dhow, visit beautiful sandbanks, snorkel vibrant coral reefs, and indulge in a delicious seafood feast served under the shade of tropical trees.
Ideal for couples, families, and private groups looking for a luxurious full-day ocean safari with everything included — from hotel transfers to fresh tropical fruits. Booking is simple: just let us know your group size and preferred date, and we’ll organize everything for you.`,
            image: blue4,
            images: [blue1, blue2, blue3],
            itinerary: [
                {
                    title: "Pick-Up & Departure from Fumba Beach",
                    description: `Your driver will pick you up from your hotel and transfer you to Fumba Village where your private dhow and crew await. After a short welcome, briefing, you’ll begin your full-day ocean safari.`,
                },
                {
                    title: "Sailing & Sandbank Relaxation",
                    description: `Begin with a relaxing sail across the Menai Bay Conservation Area, famous for its clear waters and marine life.
Visit a pristine sandbank where you can swim, sunbathe, and take stunning photos.
Enjoy tropical fruits and drinks as you relax on the beach.`,
                },
                {
                    title: "Snorkeling in Coral Reefs",
                    description: `Head to two different snorkeling sites in the bay.
Explore vibrant coral reefs filled with colorful fish and marine creatures. 
All snorkeling gear and safety equipment provided.`,
                },

                {
                    title: "Island Exploration & Lagoon Swimming",
                    description: `Visit Kwale Island for a short walk to view ancient baobab trees.
Take a refreshing swim in a natural lagoon surrounded by mangroves.`,
                },
                {
                    title: "Seafood BBQ Lunch",
                    description: `Enjoy a freshly prepared seafood BBQ served buffet-style under a shaded seating area.
Lobsters, calamari, octopus, grilled fish, chicken, rice, chapati, and more. 
Fruits, soft drinks, and local beer included.`,
                },
                {
                    title: "Return Sail to Fumba",
                    description: `After a day of sun and sea, sail back to Fumba with singing, drinks, and unforgettable memories. Your driver will transfer you back to your hotel.`,
                },



                // More itinerary items...
            ],
            inclusions: [

                "Private dhow with shade",
                "Return hotel transfers",
                "Snorkeling session with full gear",
                "Sandbank visit and beach relaxation",
                "Seafood BBQ lunch (lobster, fish, chicken, salads)",
                "Fruits, soft drinks, local beer",
                "Life jackets and snorkel masks",
                "Lagoon swimming and island visit",
                "All entrance fees and marine park charges",
                "Professional guide",
                "All government taxes and VAT"
            ],

            OptionalAddOns: [
                "Premium champagne or cocktails",
                "Proposal or anniversary setup",
            ],

        },


        {
            id: "The Rock Restaurant",
            name: "Transfer to The Rock Restaurant – Private Servic",
            category: "Private",
            startPoint: "Your Hotel",
            time: "09:00 AM",
            type: "Private | Romantic | Luxury | Unforgettable",
            price: "From Stone Town (2-5 persons): $80 | From Nungwi/Kendwa (2-5 persons): $100 | From Paje/Jambiani (2-5 persons): $120 | Larger groups: Price available on request",
            description: `Enjoy a seamless, comfortable private transfer to and from The Rock Restaurant, one of Zanzibar’s most iconic dining spots perched on a rock in the Indian Ocean near Michamvi Pingwe Beach. Whether you are visiting for lunch or dinner, we ensure timely pickup and drop-off from your hotel with professional drivers and private vehicles.`,
            image: rock,
            images: [rock4,rock5, rock2, rock3],
            itinerary: [
                {
                    title: "Pick-Up from Hotel",
                    description: `Your driver will pick you up from your hotel or accommodation anywhere in Zanzibar.
The vehicle will be a comfortable private car or 4x4, depending on your group size.
The journey to Michamvi Pingwe Beach usually takes between 1 hour to 1 hour 30 minutes, depending on your hotel location (Stone Town, Nungwi, Kendwa, etc.).`,
                },
                {
                    title: "Arrival at The Rock Restaurant",
                    description: `The driver will drop you off at the mainland beach access point near The Rock Restaurant.
From there, you can either walk (during low tide) or take a short boat. ride (during high tide) to the restaurant itself.
We can help arrange the boat transfer if needed.`,
                },
                {
                    title: "Return Transfer",
                    description: `After your meal, your driver will be ready to pick you up from the mainland beach access point to return you to your hotel safely and comfortably.`,
                },

                {
                    title: "Enjoy Your Experience",
                    description: `Relax and enjoy your time at The Rock Restaurant, known for its stunning views, delicious seafood, and unique location.`,
                },

                // More itinerary items...
            ],
            inclusions: [

                "Private round-trip transfer in a comfortable vehicle",
                "Professional, English-speaking driver",
                "Flexible pickup and drop-off times based on your reservation at The Rock",
                "Assistance with boat transfer if required",
                "All taxes and fees included"
            ],

            OptionalAddOns: [
                "Premium champagne or cocktails",
                "Proposal or anniversary setup",
            ],

        },

        {
            id: "Zanzibar-6-days-Private",
            name: "Zanzibar 6 Days / 5 Nights Package Private Tour",
            category: "Travelers seeking a perfect mix of adventure, relaxation, and cultural discovery",
            startPoint: "Zanzibar Airport",
            time: "6Days / 5 Nights",
            type: "Private | Romantic | Luxury | Unforgettable",
            price: "$950 for 2 Persons",
            description: `Enjoy a fully customized and unforgettable 6-day private tour designed just for you! This exclusive experience offers the perfect blend of adventure, relaxation, and cultural immersion. With your own personal guide and flexible itinerary, you’ll discover stunning landscapes, iconic landmarks, and hidden gems – all tailored to your interests.`,
            image: stone2,
            images: [nakupenda3, rock3, prison4, mnemba,nakupenda,mnemba1,rock2,prison2,nakupenda2,prison7,rock3,mnemba12],
            itinerary: [
                {
                    title: "Day 1: Arrival in Zanzibar",
                    description: `✈️ Warm welcome at Zanzibar International Airport, 
🚐 Private transfer to your hotel, 
🏖️ Check-in and relax by the beach or enjoy hotel amenities, 
🏨 Overnight stay at your hotel`,
                },
                {
                    title: "Day 2: Nakupenda Sandbank & Prison Island Tour",
                    description: `🐢 Visit Prison Island to explore historic ruins and meet giant Aldabra tortoises, 
🏝️ Sail to Nakupenda Sandbank for snorkeling, swimming, and sunbathing, 
🍤 Enjoy a freshly grilled seafood BBQ lunch on the sandbank, 
🌅 Return to hotel in the afternoon, 
🏨 Overnight stay at your hotel.`,
                },
                {
                    title: "Day 3: Salaam Cave & The Rock Restaurant",
                    description: `🕳️ Visit Salaam Cave, where you can swim in natural freshwater and interact with turtles
🍽️ Enjoy a visit to The Rock Restaurant, one of Zanzibar’s iconic dining spots (meals not included), 
📸 Take in breathtaking views and photos, 
🏨 Overnight stay at your hotel.`,
                },

                {
                    title: "Day 4: Mnemba Dolphin Tour & Snorkeling Adventure",
                    description: `⛵ Morning boat trip to Mnemba Atoll, 
🐬 Dolphin spotting and snorkeling with tropical marine life, 
🍉 Fresh fruits and soft drinks on board, 
🏖️ Return to hotel for relaxation, 
🏨 Overnight stay at your hotel`,
                },
                {
                    title: "Day 5: Day 5: Safari Blue Adventure",
                    description: `🚤 Full-day Safari Blue tour in Menai Bay Conservation Area, 
🐠 Snorkeling, dolphin viewing, and sandbank stop, 
🍽️ Seafood lunch buffet with lobster, calamari, fish, fruits, and drinks, 
🛥️ Sail through mangrove lagoons on a traditional dhow, 
🏨 Overnight stay at your hotel.`,
                },

                {
                    title: "Day 6: Departure Day",
                    description: `☕ Breakfast at your hotel, 
🚐 Transfer to Zanzibar Airport, 
👋 Goodbye and safe travels — Asante Sana & Karibu Tena!`,
                },



                // More itinerary items...
            ],
            inclusions: [

                "✈️ Airport pick-up & drop-off",
                "🛥️ All tours and excursions listed",
                "🍤 Seafood lunches on Days 2, 4 & 5",
                "🐢 All entry fees to parks, islands, and caves",
                "🧍 Professional English-speaking guide",
                "🥽 Snorkeling equipment",
                "🚐 Private transport during activities",
                "🥤 Soft drinks & fresh fruits during boat trips",
                "🧾 All government taxes and VAT"
            ],

            OptionalAddOns: [
                "Premium champagne or cocktails",
                "Proposal or anniversary setup",
            ],

        },
        {
            id: "Maalum CavePrivate",
            name: "Maalum Cave & Salaam Cave Private Day Tour",
            category: "Private",
            startPoint: "Paje Town",
            time: "08:00 AM",
            type: "Private | Romantic | Luxury | Unforgettable",
            price: "$230 for two persons | $275 for three persons | $290 for four persons | $80 for 5-10 per person | $70 for 11+ per person",
            description: `The Maalum Cave & Salaam Cave day trip is a unique wellness and nature experience that takes you deep into Zanzibar’s hidden underground water worlds. Enjoy a peaceful swim in two naturally formed caves, surrounded by coral rock and tropical forest. This private day trip offers tranquility, natural beauty, and cultural connection.
Perfect for couples, solo travelers, or wellness-focused groups looking for relaxation, beautiful nature, and local healing spaces. Booking is easy — just share your preferred date and group size, and we’ll organize the full experience with transfers, entry, and refreshments included.`,
            image: maa1,
            images: [maa5,sal1, maa4,sal2, maa3,sal3,maa2],
            itinerary: [
                {
                    title: "Hotel Pick-Up & Transfer",
                    description: `Our driver will collect you from your hotel and take you to the first cave — Salaam Cave — located in a peaceful part of Zanzibar’s countryside.`,
                },
                {
                    title: "Stop 1: Salaam Cave",
                    description: `Discover this serene, open-air cave 
Swim in the cool, fresh-water pool beneath tall coral stone walls, 
Swim with turtles and feed them .`,
                },
                {
                    title: "Stop 2: Maalum Cave",
                    description: `Arrive at the mineral-rich and photogenic Maalum Cave,
Swim in the clear turquoise pool surrounded by glowing cave walls,  
Use floating pillows or life jackets provided for your comfort,   
Perfect for wellness, content creation, or couples photos.`,
                },

                {
                    title: "Fruits & Refreshments",
                    description: `Cold soft drinks and bottled water included, 
Optional spa services (massages, scrubs) available on site at extra cost.`,
                },
                {
                    title: "Return to Hotel",
                    description: `Your driver will take you back to your hotel after a peaceful and unforgettable day.`,
                },



                // More itinerary items...
            ],
            inclusions: [

                "Private round-trip hotel transfers",
                "Entry to Maalum Cave and Salaam Cave",
                "Guided cave experience and swimming session",
                "Life jackets and floatation pillows",
                "Transfer to nearby restaurant for lunch (food cost at your own)",
                "Professional guide",
                "All local and government fees",
                "All taxes and VAT"
            ],

            OptionalAddOns: [
                "Premium champagne or cocktails",
                "Proposal or anniversary setup",
            ],

        },


        {
            id: "prison & stone town private",
            name: "Stone Town & Prison Island Private Tour",
            category: "Private",
            startPoint: "Stone Town Beach",
            time: "08:00 AM",
            type: "Private | Romantic | Luxury | Unforgettable",
            price: "$210 for two persons | $240 for three persons | $280 for four persons | $70 for 5-10 per person | $60 for 11+ per person",
            description: `This private half-day cultural and historical experience blends the charm of Stone Town with a boat trip to the famous Prison Island. You’ll explore the heritage of Zanzibar on foot with a local guide, then visit Aldabra giant tortoises, colonial ruins, and the turquoise waters of Changuu Island.
Ideal for couples, families, and history lovers who want to dive into Zanzibar’s rich past and natural beauty. Easy to book — just tell us your group size and we’ll handle all logistics, including entry tickets, transfers, and guided tours.`,
            image: stone4,
            images: [prison7, stone3, prison6, stone5,prison5, stone2, stone, stone8, stone13, stone10, stone11, stone12 ,prison4,prison2],
            itinerary: [
                {
                    title: "Hotel Pick-Up & Transfer to Stone Town",
                    description: `Your driver will pick you up from your hotel and transfer you to the city center where your walking tour begins.`,
                },
                {
                    title: "Stop 1: Stone Town Historical Walking Tour",
                    description: `Guided walk through UNESCO-listed Stone Town, 
Visit landmarks such as the House of Wonders, Old Slave Market, Darajani Bazaar, and more, 
Learn about Zanzibar’s blend of Swahili, Arab, and colonial cultures, 
Explore narrow alleys, admire intricate doors, and interact with locals in the market.`,
                },
                {
                    title: "Stop 2: Prison Island (Changuu Island)",
                    description: `Short traditional boat ride to Prison Island, just 20 minutes off the coast
Visit the sanctuary of the giant Aldabra tortoises, 
Walk among them, feed them, and take photos — some are over 150 years old!, 
Explore the ruins of the old quarantine hospital and colonial prison, 
Swim or relax on the beach with views of the Stone Town skyline.`,
                },


                {
                    title: "Return to Stone Town & Transfer to Hotel",
                    description: `after exploring the island, you’ll return by boat to Stone Town. Your driver will take you back to your hotel after the tour..`,
                },



                // More itinerary items...
            ],
            inclusions: [

                "Private hotel pick-up and drop-off",
                "English-speaking professional guide",
                "Stone Town walking tour",
                "Boat ride to and from Prison Island",
                "Entrance fees to Prison Island and all sites visited",
                "Bottled drinking water",
                "All local taxes and government fees",
                "All VAT"
            ],

            OptionalAddOns: [
                "Premium champagne or cocktails",
                "Proposal or anniversary setup",
            ],

        },
        {
            id: "Spice Farm & stone town private",
            name: "Spice Farm & Stone Town Private Tour",
            category: "Private",
            startPoint: "Stone Town Beach",
            time: "08:00 AM",
            type: "Private | Romantic | Luxury | Unforgettable",
            price: "$180 for two persons | $210 for three persons | $250 for four persons | $60 for 5-10 per person | $50 for 11+ per person",
            description: `This private day tour takes you deep into the history, culture, and flavors of Zanzibar. Start with a guided walking tour of Stone Town, a UNESCO World Heritage site known for its narrow alleys, bustling bazaars, and centuries-old buildings. Then head out to a traditional Spice Farm, where you’ll smell, taste, and touch the spices that made Zanzibar famous around the world.
Perfect for travelers who want to connect with the local culture and cuisine of Zanzibar in a single day. Book easily by telling us your group size and preferred date — and we’ll take care of everything from hotel pick-up to a traditional lunch on the farm.`,
            image: spice2,
            images: [spice3, spice4,spice5, spice7,spice,spice1 ],
                itinerary: [
                    {
                        title: "Hotel Pick-Up & Transfer to Stone Town",
                        description: `your day begins with a comfortable transfer to the heart of Stone Town where you’ll meet your local guide.`,
                    },
                    {
                        title: "Stop 1: Stone Town Historical Tour",
                        description: `Explore Stone Town’s historic landmarks with a knowledgeable local guide, 
Visit the Old Fort, House of Wonders, Freddie Mercury’s House, and more, 
Walk through bustling local markets and admire the Zanzibari doors and architecture, 
Learn about the island’s Swahili, Arab, Indian, and European heritage.`,
                    },
                    {
                        title: "Transfer to Spice Farm",
                        description: `After the walking tour, you’ll be driven to a rural spice plantation just outside of town.`,
                    },


                    {
                        title: "Stop 2: Spice Farm Tour & Lunch",
                        description: `Walk through the farm with a guide who will let you see, smell, and taste spices like:
 Cloves, Cinnamon, Cardamom, Nutmeg, Turmeric, Ginger, Vanilla, Black Pepper, Lemongrass 
 Learn how these spices are grown, harvested, and used in Zanzibari cooking, 
Watch a live coconut tree climbing demo and taste fresh coconuts, 
Enjoy a traditional spiced rice lunch served with fish, vegetables, and fresh fruits.`,
                    },



                    {
                        title: "Optional Shopping & Return to Hotel",
                        description: `You’ll have the chance to shop for fresh spices, oils, soaps, and teas directly from the farm, 
Afterward, your driver will take you back to your hotel.`,
                    },



                    // More itinerary items...
                ],
                inclusions: [

                    "Private round-trip hotel transfers",
                    "Stone Town guided historical walking tour",
                    "Entrance fees to museums and landmarks",
                    "Guided Spice Farm tour",
                    "Traditional Zanzibari spiced lunch",
                    "Bottled water",
                    "Professional cultural guide",
                    "All government fees and local taxes",
                    "All VAT"
                ],

                OptionalAddOns: [
                    "Premium champagne or cocktails",
                    "Proposal or anniversary setup",
                ],

        },

        {
            id: "Nakupenda only-private",
            name: "Nakupenda SandBank Private Day Trip",
            category: "Private",
            startPoint: "Stone Town Beach",
            time: "08:00 AM",
            type: "Private | Romantic | Luxury | Unforgettable",
            price: "$170 for two persons | $200 for three persons | $240 for four persons | $55 for 5-10 per person | $50 for 11+ per person",
            description: `Experience the pristine beauty of Nakupenda Sandbank, a stunning natural sandbank located off the coast of Stone Town. This private trip offers a perfect day of swimming, sunbathing, snorkeling, and relaxation in crystal-clear turquoise waters. Ideal for travelers seeking a serene escape from the busy town, this trip includes a private boat, delicious seafood lunch, drinks, and snorkeling gear.
Perfect for couples, families, or groups who want to enjoy an exclusive beach day surrounded by Zanzibar’s breathtaking marine environment. Booking is easy—just tell us your group size and preferred date.`,
            image: nakupenda,
            images: [nakupenda1, nakupenda2, nakupenda3],
            itinerary: [
                {
                    title: "Hotel Pick-Up & Transfer to Stone Town",
                    description: `Your driver will collect you from your hotel and transfer you to Stone Town Beach where your private boat awaits.`,
                },
                {
                    title: "Boat Ride to Nakupenda Sandbank",
                    description: `Board a comfortable local boat equipped with music, seating, and shade, 
Sail through scenic waters toward the famous Nakupenda Sandbank.`,
                },
                {
                    title: "Sandbank Relaxation & Activities",
                    description: `Spend your day relaxing on the expansive white sand surrounded by crystal-clear waters,
Swim in the shallow lagoon or snorkel to discover colorful coral reefs and tropical fish, 
Sunbathe and take in the stunning natural scenery, 
Optional beach games and photo sessions.`,
                },


                {
                    title: "Lunch on Board",
                    description: `Enjoy a freshly prepared seafood lunch featuring grilled fish, chicken, rice, and tropical fruits
Accompanied by soft drinks, bottled water, and local beers, 
Music playing softly onboard for a perfect atmosphere.`,
                },



                {
                    title: "Return to Stone Town",
                    description: `After a leisurely day, back to Stone Town Beach. Your driver will be waiting to transfer you back to your hotel.`,
                },



                // More itinerary items...
            ],
            inclusions: [

                "Private local boat",
                "Professional guide and crew",
                "Seafood lunch (grilled fish, chicken, rice, fruits)",
                "Soft drinks, bottled water",
                "Snorkeling gear and life jackets",
                "Hotel transfers ",
                "All entrance and marine park fees",
                "All government taxes and VAT"
            ],

            OptionalAddOns: [
                "Premium champagne or cocktails",
                "Proposal or anniversary setup",
            ],

        },
        // Add private tours data...
    ],
    sharing: [
        {
            id: "safari-blue-sharing",
            name: "Safari Blue Sharing Tour - Full Day",
            category: "sharing",
            startPoint: "Fumba beach",
            time: "08:00 AM",
            type: "🌍 All languages are welcome - English, French, Italian, and more.",
            price: "$70 per person(nungwi) | $85 per person(Paje/michamvi/jambiani)",
            description:
                `Experience the magic of Zanzibar’s Safari Blue, one of the most popular ocean adventures, now available as an affordable shared group tour. Sail the sparkling turquoise waters of Menai Bay, visit pristine sandbanks, snorkel colorful coral reefs, and enjoy a delicious seafood BBQ—all while meeting fellow travelers.
Ideal for solo adventurers, couples, and small groups who want to explore the marine beauty of Zanzibar without the private charter price tag. Relax in the company of others and soak up the sun, sea, and culture.`,
            image: blue2,
            images: [blue4, blue3, blue1],
            itinerary: [
                {
                    title: "🚐 Hotel Pick-Up & Transfer to Fumba Beach",
                    description: `Pickup from your hotel in:
 Nungwi ($70 per person)
 Paje ($85 per person)
 Michamvi ($85 per person)
 Jambiani ($85 per person)
 Tansfer to Fumba Village, where your shared dhow and crew await.`,
                },
                {
                    title: "⛵ Sailing & Sandbank Visit",
                    description: `Set sail across the calm, crystal-clear waters of Menai Bay Conservation Area.
 Visit a stunning sandbank to swim, relax, and take photos
Refresh with tropical fruits and soft drinks while basking on white sands`,
                },
                {
                    title: "🤿 Snorkeling in Vibrant Coral Reefs",
                    description: `Explore two of the bay’s best snorkeling spots, guided by expert crew.
Swim among colorful corals and tropical fish
Snorkeling gear and safety equipment provided
Suitable for all skill levels`,
                },
                {
                    title: "🏝️ Island Visit & Lagoon Swim",
                    description: `Visit Kwale Island for a nature walk among ancient baobab trees.
                Swim in a peaceful lagoon surrounded by mangroves`,
                },
                {
                    title: "🍽️ Seafood BBQ Lunch",
                    description: `Enjoy a buffet-style seafood feast under the shade:
Lobsters, calamari, octopus, grilled fish, chicken, rice, chapati, salads
Local beer, soft drinks, and fresh fruits included`,
                },
                {
                    title: "⛵ Return Sail & Hotel Drop-Off",
                    description: `After a day full of adventure and relaxation, sail back to Fumba with drinks and local music onboard. Your driver will return you to your hotel.`,
                },


                // More itinerary items...
            ],
            inclusions: [
                " ✔️ Shared traditional dhow with shaded seating",
                "✔️ Return hotel transfers from listed locations",
                "✔️ Guided snorkeling with full gear",
                "✔️ Sandbank visit and beach relaxation",
                "✔️ Seafood BBQ lunch and drinks (beer, soft drinks, fruits)",
                "✔️ Island and lagoon swim",
                "✔️ Life jackets and snorkel masks",
                "✔️ Marine park fees, government taxes, and VAT",
                "✔️ Multilingual professional guide and crew"
            ],
            whatToBring: [
                "Swimsuit & towel",
                "Sun hat & sunscreen",
                "Sunglasses",
                "Waterproof bag for electronics",
                "Flip-flops or reef shoes",
            ],
            OptionalAddOns: [
                "📆 Tour runs every Thursday",
                "📩 Booking required at least 3 days in advance",
            ],
        },

        {
            id: "Prison & Nakupenda-sharing",
            name: "Prison Island & Nakupenda SandBank Group Tour",
            category: "Sharing",
            startPoint: "Stone Town beach",
            time: "Every Tuesday",
            type: "🌍 All languages are welcome! Our guides speak English, French, Italian, and more.",
            price: "$70 per Person (Nungwi) | $70 per person (Paje) | $80 per person (Michamvi)",
            description: `Join our shared group tour every Tuesday and experience the best of Zanzibar in one amazing day! Discover the history of Prison Island, home to the giant Aldabra tortoises, and unwind at Nakupenda Sandbank, surrounded by clear turquoise waters.
Whether you’re a solo traveler, couple, or small group, this trip offers a mix of culture, beach relaxation, snorkeling, and a delicious seafood lunch—all at an affordable price!`,
            image: prison2,
            images: [nakupenda2, prison, nakupenda1,prison6,nakupenda,prison4,nakupenda3,prison7,nakupenda4,prison2,prison5],
            itinerary: [
                {
                    title: "🚐 Hotel Pick-Up",
                    description: `Pickup from your hotel in:
 Nungwi ($70 per person), 
 Paje ($85 per person), 
 Michamvi ($85 per person), 
 Jambiani ($85 per person), transfer you to Stone Town Beach.` },
                {
                    title: "🛶 Board the Boat & Set Sail",
                    description: `Meet your guide and board a shared boat with music, shade, and refreshments.`,
                },
                {
                    title: "📍 Stop 1: Prison Island (Changuu Island)",
                    description: `Guided tour of the old quarantine station and colonial ruins, 
Meet and feed the giant tortoises, some over 150 years old, 
Take beautiful photos and learn about the island’s history.`,
                },

                {
                    title: "📍 Stop 2: Nakupenda Sandbank",
                    description: `After a relaxing afternoon, sail back to Stone Town and transfer back to your hotel.`,
                },
                {
                    title: "⛵ Return & Hotel Drop-Off",
                    description: `After a relaxing afternoon, sail back to Stone Town and transfer back to your hotel.`,
                },




                // More itinerary items...
            ],
            inclusions: [

                " ✔️ Group boat shade",
                "✔️ Entrance fees to Prison Island",
                "✔️ Professional multilingual guide",
                "✔️ Seafood lunch (fish, prawns, chicken, rice, salad, fruits)",
                "✔️ Soft drinks, bottled water, and local beer",
                "✔️ Snorkeling gear and life jackets",
                "✔️ Round-trip hotel transfers from Nungwi, Paje, or Michamvi",
                "✔️ Government taxes and marine park fees",
            ],

            OptionalAddOns: [
                "📆 runs Every Tuesday",
                "📞 Reserve at least 3 days before your tour date",
            ],

        },

        {
            id: "Kendwa sunset-sharing",
            name: "Kendwa Sunset Cruise Group Tour",
            category: "Sharing",
            startPoint: "kendwa beach",
            time: "17:00 PM",
            type: "🌍 All languages are welcome! Our guides speak English, French, Italian, and more.",
            price: "$100 per Person | $150 per person ",
            description: `join fellow travelers for a magical Kendwa Sunset Cruise, sailing along Zanzibar’s breathtaking northern coastline aboard a traditional dhow. As the sun melts into the horizon, enjoy soft music, cold drinks, and a warm sea breeze.
Whether you're a solo traveler, couple, or small group, this shared experience is the perfect way to end your day in Zanzibar — with stunning views, good vibes, and unforgettable memories.`,
            image: sunset4,
            images: [sunset3, sunset6, sunset,sunset2,sunset1,sunset4],
            itinerary: [
                {
                    title: "🚐 Hotel Pick-Up & Transfer to Kendwa Beach",
                    description: `Pickup from your hotel in:
💰 Pricing
$100 per person
✅ Includes transfers from:
 Stone Town, Kiwengwa, Uroa, Nungwi, Matemwe, Pwani Mchangani.
$150 per person
✅ Includes transfers from:
 Michamvi, Bwejuu, Paje, Jambiani, Kizimkazi.
 our driver will collect you from your hotel and bring you to Kendwa Beach, where the cruise begins.
` },
                {
                    title: "🌅 Sunset Sailing Experience",
                    description: ` Cruise along the coastline of Kendwa and Nungwi,
 Enjoy the breathtaking colors of the sunset,
 Great for photos and social moments.`,
                },
                {
                    title: "🍹 Drinks & Light Snacks",
                    description: ` Soft drinks, bottled water, and light snacks
`,
                },

                {
                    title: "🚐 Return Transfer",
                    description: `After the cruise, you’ll return to Kendwa Beach and your driver will take you back to your hotel.`,
                },
                {
                    title: "📌 Important Notes:",
                    description: `🕒 Departure Time: ~4:00 PM.`,
                },

                {
                    title: "Pick from hotel 2 hours before",
                    description: ` 📆 Duration: Approx. 2.5 hours,
 📲 Booking required at least 2 days in advance,
 🚤 Available Daily, subject to weather and availability,
📞 Reserve your spot now — limited space available each day!`,
                },

                // More itinerary items...
            ],
            inclusions: [

                " ✔️ Group boat shade",
                "Shared sunset dhow cruise",
                "Hotel transfers (round trip)",
                "Soft drinks, bottled water & snacks",
                "Experienced crew",
                "All taxes and marine fees",
            ],

            OptionalAddOns: [

            ],

        },

        {
            id: "Mnemba-sharing",
            name: "Mnemba Dolphin & Snorkeling Group Tuor",
            category: "Sharing",
            startPoint: "Matemwe beach",
            time: "Every WednesDay",
            type: "🌍 All languages are welcome! Our guides speak English, French, Italian, and more.",
            price: "$65 per Person | $80 per person | $90 per person ",
            description: `oin fellow travelers for a magical Kendwa Sunset Cruise, sailing along Zanzibar’s breathtaking northern coastline aboard a traditional dhow. As the sun melts into the horizon, enjoy soft music, cold drinks, and a warm sea breeze.
Whether you're a solo traveler, couple, or small group, this shared experience is the perfect way to end your day in Zanzibar — with stunning views, good vibes, and unforgettable memories.`,
            image: mnemba,
            images: [mnemba1, mnemba2,mnemba8, mnemba4,mnemba10,mnemba7,mnemba12,mnemba3,mnemba5,mnemba6,mnemba8,mnemba9],
            itinerary: [
                {
                    title: "🚐 Hotel Pick-Up & Transfer to Kendwa Beach",
                    description: `Your adventure begins with an early morning pick-up from your hotel, available from:
💰 Pricing
$65 per person
✅ Includes transfers from:
 Stone Town, Kiwengwa, Uroa, Nungwi, Matemwe, Pwani Mchangani.
$80 per person
✅ Includes transfers from:
 Bwejuu, Paje, Jambiani, Kizimkazi.
 $90 per person
✅ Includes transfers from:
 Michamvi.
You’ll travel comfortably to Matemwe Beach, a beautiful departure point in the northeast of Zanzibar, where your boat crew and guide will be waiting.
` },
                {
                    title: "🐬 Dolphin Watching – Ethical & Respectful",
                    description: ` Hop aboard a well-equipped local boat and cruise into the calm waters off the Mnemba coast, where wild bottlenose dolphins are often spotted in their natural habitat.
 Watch as dolphins swim, leap, and glide through the water in playful pods
 Capture amazing photos and videos from the boat,
 We operate strictly ethical practices—we observe from a respectful distance and never chase or harass the animals
 This part of the trip is about connecting with nature, not disturbing it.`,
                },
                {
                    title: "🤿 Snorkeling at Mnemba Atoll Reef",
                    description: ` After your dolphin encounter, your next stop is near the famous Mnemba Atoll, considered one of the best snorkeling spots in East Africa.
 Jump into crystal-clear waters full of colorful corals and tropical fish,
 All equipment is included (mask, fins, snorkel, life jackets),
 Your guide will assist you throughout, making it perfect for both beginners and experienced snorkelers,
 Enjoy time floating peacefully, discovering the underwater world beneath you`,
                },

                {
                    title: "🍽️ Seafood Lunch on a Beautiful Beach",
                    description: `Once you've explored beneath the waves, you'll head to a nearby quiet beach to relax and recharge with a delicious local-style lunch:
 Freshly grilled fish, prawns, chicken, rice, salad, and flavorful local sauces,
 Tropical fruits like pineapple, watermelon, and bananas,
 Soft drinks and bottled water available to keep you refreshed,
 Music and ocean views complete the experience`,
                },
                {
                    title: "⛵ Relaxation & Return to Hotel",
                    description: `After your meal and some beach time, enjoy a slow and scenic sail back to shore. Soak in the sun, sip a drink, and chat with fellow travelers as you return to Matemwe. Your driver will be ready to take you back to your hotel for a well-earned rest.`,
                },

                {
                    title: "📌 Important Notes:",
                    description: ` 📆 This tour runs every Wednesday – please note that advance booking (minimum 3 days prior) is required to secure your seat. 🕖 Departure time: Morning pick-up (exact time confirmed after booking)`,
                },

                // More itinerary items...
            ],
            inclusions: [

                "✔️ Comfortable shared boat with music, shade, and safety gear",
                "✔️ Guided dolphin watching (respectful and eco-conscious)",
                "✔️ Snorkeling gear (masks, fins, life jackets)",
                "✔️ Professional, multilingual tour guide",
                "✔️ Freshly cooked seafood lunch on the beach (fish, prawns, chicken, salad, rice, fruits)",
                "✔️ Soft drinks, bottled water, tropical fruits",
                "✔️ Round-trip hotel transfers from all listed areas",
                "✔️ Marine park fees and government taxes",
                "✔️ Friendly service from a dedicated crew",
            ],

            OptionalAddOns: [

            ],

        },
        // Add sharing tours data...
    ],
    optional: [
        {
            id: "optional",
            name: "Optional Add-On Activities(Per person)",
            category: "Optional",
            startPoint:"Horse Riding",
            time: "AnyTime",
            type: "Private | Romantic | Luxury | Unforgettable",
            price: "$70for per persons | $120 per persons | $100 per persons ",
            description: `Boost your Zanzibar experience with these popular activities. You can add them anytime during your stay, unless otherwise specified.`,
              image: farasi4,
            images: [farasi2, nakupenda2,kayaking,quad,farasi1, nakupenda3,farasi5,nakupenda,farasi3,nakupenda4],
            itinerary: [
                {
                    title: "Activity",
                    description: `🐎  Horse Riding, 🛶 Transparent Kayaking + Drone Video, 📸 Drone Photoshoot – Nakupenda, 🛻  Quad Bike Adventure`,
                },
                {
                    title: "Price (Per Person)",
                    description: `🐎 Horse Riding – Michamvi Stable	$70 for 30min | $130 for 1hr ,  🛶 Transparent Kayaking + Drone Video	$120, 📸 Drone Photoshoot – Nakupenda	$120, 🛻 Quad Bike Adventure	$100`,
                },
                {
                    title: "Notes",
                    description: `🐎 Horse Riding  Michamvi Stable - No advance booking needed – available daily | 🛶 Transparent Kayaking + Drone Video -Includes HD drone footage during kayaking (Kendwa area) | 📸 Drone Photoshoot – Nakupenda - 20–30 aerial drone photos + video on Nakupenda Sandbank | 🛻 Quad Bike Adventure - Guided off-road route through villages, forest & coastal areas.`,
                },


                {
                    title: "🚐 Transfer Policy (If Activities Are Booked Separately)",
                    description: `If you book only the activities without the main tour package: Group Size (1 to 6 Persons) Transfer Cost ($120 per roundtrip) | Group Size (7+ Persons) Transfer Cost ($160 per roundtrip).`,
                },



                {
                    title: "Important",
                    description: `✅ No transfer fee if activities are added within the main Zanzibar tour package.`,
                },



                // More itinerary items...
            ],
            inclusions: [

                "Private local boat",
                "Professional guide and crew",
                "Soft drinks, bottled water",
                "Hotel transfers ",
                "All entrance and marine park fees",
                "All government taxes and VAT"
            ],

            OptionalAddOns: [
                "Premium champagne or cocktails",
                "Proposal or anniversary setup",
            ],

        },

    ],
    transfer:[
        {
            id: "transfer",
            name: "🚐 Zanstone Transfers Price List",
            category: "transfer",
            startPoint:"Airport",
            time: "AnyTime",
            type: "Comfortable, Reliable & Safe Transport Across Zanzibar",
            price: "$50 | $45 | $80 | $120 | $100",
            description: `We offer private transfers with modern, well-maintained vehicles and professional drivers. Your safety and luggage security are always our top priority` ,
            image: car6,
            images: [car5, car4, car3,car2,car1],
            itinerary: [
                {
                    title: "📍 From Zanzibar Airport",
                    description: `To Kendwa, Nungwi, Matemwe, Pwani Mchangani
• 1–4  persons: $50,
• 5+ persons: $100`,
                },
                {
                    title: "📍 From Zanzibar Airport",
                    description: `To Stone Town, Kiwengwa, Uroa
• 1–4 persons: $45,
• 5+ persons: $80`,
                },
                {
                    title: "📍 From Zanzibar Airport",
                    description: `To Paje, Kizimkazi, Jambiani, Bwejuu, Michamvi
 1–4 persons: $80, 
 5+ persons: $120`,
                },


                {
                    title: "📍 Between Coastal Areas",
                      description: `From Nungwi, Kendwa, Matemwe, Pwani to Paje, Jambiani, Kizimkazi, Michamvi
 1–4 persons: $70,
 5+ persons: $100`
                },



                {
                    title: "📍 From Stone Town to Other Areas",
                    description: ` 1–4 persons: $50,
 5+ persons: $90`,
                },
                 {
                    title: "📍 From Uroa or Kiwengwa to Other Places",
                    description: ` 1–4 persons: $60
 5+ persons: $100`,
                },
                {
                    title: "🛡️ Why Choose Zanstone Transfers?",
                    description: ` ✅ Spacious, clean, and air-conditioned vehicles
✅ Friendly, experienced, and punctual drivers
✅ Guaranteed luggage safety and door-to-door service
✅ 24/7 customer support
✅ Fixed transparent pricing with no hidden charges`,
                },
                
                 {
                    title: "important",
                    description: `Let us take the stress out of your travel—book your transfer now with Zanstone for a smooth and secure journey across the island!`,
                },


                // More itinerary items...
            ],
            inclusions: [

            
                "Professional guide and crew",
                "Hotel transfers ",
                "All government taxes and VAT"
            ],

            OptionalAddOns: [
                "Premium champagne or cocktails",
                "Proposal or anniversary setup",
            ],

        },
    ]
};

export const getTourById = (id) => {
    for (const category in allTours) {
        const foundTour = allTours[category].find((tour) => tour.id === id);
        if (foundTour) return foundTour;
    }
    return null;
};
